import * as yup from "yup";

export const assignedEndUserSchema = yup.object().shape({
  first_name: yup.string().required().default("").label("First name"),
  last_name: yup.string().required().default("").label("Last name"),
  email: yup.string().email().required().default("").label("Email"),
  reminderTypeIds: yup.array().of(yup.number()).required().min(1).label("One or more"),
  // terms_and_conditions: yup.string().label("Terms and Condition"),
});
